
import TopBar from 'elements/TopBar/TopBar';
import DateBar from 'elements/DateBar';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { getCalendarioLiturgicoLabel } from 'hooks/useLabels';



export default function LiturgiaHorasCategories(props: any) {
  

    useEffect (() => {
        props.setLoading(false);
    }, [])


  return (
    <div id='LiturgiaHorasCategories' className='module_container'>
      
      <div className="module_topBar">
        <TopBar title={getCalendarioLiturgicoLabel('liturgia_horas_titulo')}/>
      </div>
      
      <DateBar />
     

      
      <div className='module_content'>
        <div id="liturgiaHoras_categories" className="flex_column">
          

            <div className='CardList'>
              <Link to='/liturgia-horas/oficio-lectura' className='icon' onClick={() => props.setLoading(true)}> 
                <span className='CardListTitle'>{getCalendarioLiturgicoLabel('oficio_lectura')}</span>
              </Link>
            </div>

            <div className='CardList'>
              <Link to='/liturgia-horas/laudes' className='icon' onClick={() => props.setLoading(true)}> 
                <span className='CardListTitle'>{getCalendarioLiturgicoLabel('laudes')}</span>
              </Link>
            </div>

            <div className='CardList'>
              <Link to='/liturgia-horas/intermedias' className='icon' onClick={() => props.setLoading(true)}>
                <span className='CardListTitle'>{getCalendarioLiturgicoLabel('horas_intermedias')}</span>
              </Link>
            </div>
           
            <div className='CardList'>
              <Link to='/liturgia-horas/visperas' className='icon' onClick={() => props.setLoading(true)}>
                <span className='CardListTitle'>{getCalendarioLiturgicoLabel('visperas')}</span>
              </Link>
            </div>

            <div className='CardList'>
              <Link to='/liturgia-horas/completas' className='icon' onClick={() => props.setLoading(true)}>
                <span className='CardListTitle'>{getCalendarioLiturgicoLabel('completas')}</span>
              </Link>
            </div>

            
        </div>
      </div>
    </div>
  );
};



